import React, { useState, useEffect, Component } from 'react';
import { IoAddOutline } from "react-icons/io5";
import { toast } from 'react-toastify';

const InventoryList = ({ dataList, item, setDataList }) => {
    const [formData, setFormData] = useState({
        LeaseNo: "",
        Item: "",
        Details: "",
        Location: "",
        Quantity: "",
    })
    const handleGridChange = (index, key, value) => {
        setDataList((prev) => {
            const updatedList = [...prev];
            let row = { ...updatedList[index] };
            row[key] = value;
            updatedList[index] = row;
            return updatedList;
        });
    }
    const handleAddNew = () => {
        if (formData?.Item) {
            setDataList(prev => [
                ...prev,
                {
                    LeaseNo: item?.leaseNo,
                    Item: formData?.Item,
                    Details: "",
                    Quantity: 0.00,
                    Location: "",
                }
            ]);
            setFormData({
                LeaseNo: "",
                Item: "",
                Details: "",
                Location: "",
                Quantity: "",
            });
        } else {
            toast.warning("Please Enter Item")
        }
    }
    const handlefieldChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    return (
        <div className='gridshad'>
            <div className='p-3 d-flex justify-content-between'>
                <div><h4>Lease No :   {item?.leaseNo || "---"}</h4></div>
                <div className='col-4 d-flex gap-3'>
                    <div
                        className='mainbtnGry flex-end gap-2' onClick={handleAddNew}>
                        <IoAddOutline color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Add</div>
                    </div>
                   <input className='p-2 form-control' placeholder='Enter Item' name='Item' onChange={handlefieldChange} value={formData?.Item} />
                </div>
            </div>
            <div className='table-container' style={{ overflowX: 'auto', height: "550px" }}>
                <table className='table table-bordered gridshad'>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Location</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(dataList) && dataList?.map((data, index) => (
                            <tr>
                                <td><input value={data?.Item} className='p-1 w-100' disabled /></td>
                                <td style={{ width: "150px" }}><input value={data?.Quantity} className='p-1 w-100'
                                    onChange={(e) => handleGridChange(index, "Quantity", e.target.value)} /></td>
                                <td><input value={data?.Location} className='p-1 w-100'
                                    onChange={(e) => handleGridChange(index, "Location", e.target.value)} /></td>
                                <td><input value={data?.Details} className='p-1 w-100'
                                    onChange={(e) => handleGridChange(index, "Details", e.target.value)} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default InventoryList;